module.exports = __webpack_public_path__ + "assets/img/bg.bdcf7a6c.png";